import { defineNamespace } from '@/i18n';
import { en } from './en';
import { fr } from './fr';

/** The experiences feature's messages: `const t = useT(messages)`. */
export const messages = defineNamespace('experiences', fr, en);
